import styled from 'styled-components';
import { getRenderViewURL } from '../../../../common/renderer/get-render-view-url';
import { InternalLink } from '../../../common/generic/components/navigation/internal-link';
import { getBouLinkStyle } from '../../../common/generic/content/texts/bou-link';
import { useRenderViewContext } from '../context';
import { ControlRoot, ControlRowContent, ControlRowLabel } from './shared';

export const DevTools = () => {
  const { options } = useRenderViewContext();
  const url = getRenderViewURL(options);

  return (
    <ControlRoot>
      <ControlRowLabel>Dev tools</ControlRowLabel>
      <ControlRowContent>
        <StyledLink to={url} target="_blank">
          Open in new tab
        </StyledLink>
      </ControlRowContent>
    </ControlRoot>
  );
};

const StyledLink = styled(InternalLink)`
  ${getBouLinkStyle()}
`;
